import type { FaireProductEntity } from "../../entity_types/product";

export const p_23kwv69wex: FaireProductEntity = {
  token: "p_23kwv69wex",
  type: "product",
  name: "Coconut Oat Milk Bath Bomb",
  brandToken: "b_z8zxh7hf3n",
  brandName: "Bathology by Yaphiah",
  imageUrl:
    "https://cdn.faire.com/fastly/9ce72dd54f82d9210dd73f41ea97ec228c4af037471fb871bdea5ad363413e94.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.47,
  description:
    "This bath bomb is the Bomb! The coconut milk and oats leave your skin feeling so silky. It’s healing to the skin and relaxing to the mind.\n\nApproximately 8.3oz large bath bombs.\n\nIngredients: Baking soda, coconut milk powder, colloidal oats, epsom salt, dendritic salt, citric acid, corn starch, cream of tartar, coconut oil, essential oil, polysorbate 80, dried lavender buds, and dried rose petals.\n\nWarning: This product contains oils, which was cause your bathtub or shower to be slippery. Be cautious! Not for use on children.",
  tags: [],
  msrpDollars: 8.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:20.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
